module.exports = __webpack_public_path__ + "img/dutyfree_1820111.webp";